// File: Clients/webcalendar/src/components/layout/AutoSwitchLayout.jsx
import React from "react";
import { useAuthentication } from "../../global/authentication";
import { MasterLayout } from "./MasterLayout";
import { BlankLayout } from "./BlankLayout";

export function AutoSwitchLayout({ children, routes }) { // Accept routes as a prop
  const { isAuthenticated } = useAuthentication();
  const Layout = isAuthenticated ? MasterLayout : BlankLayout;

  return <Layout routes={routes}>{children}</Layout>; // Pass routes to MasterLayout
}
